<template>
  <div class="account-page__mine app-page">
    <!-- <div class="app-bg-container account-page__page-bg" :style="{'background-image':`url(${$store.getters.getBaseInfo.center_bg})`}">
      <div class="app-bg-wrapper"></div></div> -->

    <!-- <div class="account-page__page-bg"></div> -->
    <div class="app-wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
        :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
        <div class="app-header">
          <!-- <van-nav-bar class="app-nav-bar" :style="{'background':$store.getters.getBaseInfo.center_bg?'none':'background: linear-gradient(90deg,#f43443,#e6c3a1)'}">
             <template #right>
               <van-icon name="setting-o" @click="showSetting()" color="#fff"/>
             </template>
</van-nav-bar> -->
          <div class="account-page__user-wrapper" @click="doLogin()">
            <van-image round class="account-page__user-img" :src="this.userInfo.header_img">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <div class="account-page__login-content">
              <p class="app-login-btn">{{ this.userInfo.username }}
              </p>
              <p class="account-page__login-btn2">{{ $t('zise.shengyucishu') }}:0
              </p>
              <p class="account-page__login-btn2">{{ $t('my.point') }}:{{ userInfo.point }}
              </p>

              <!-- <p class="account-page__login-label" v-if="this.userInfo && this.userInfo.groupinfo">
                <van-progress :percentage="this.userInfo.groupinfo.rate" :show-pivot="false" stroke-width="8px"
                  color="linear-gradient(270deg,  #f43443, #f43443)" />
              </p> -->
            </div>
            <div class="account-page__login-content1" v-if="this.userInfo.groupinfo" style="text-align: center;"><p class="account-page__login-btn1"> {{this.userInfo.groupinfo.name}} </p></div>
          </div>
        </div>

        <van-cell :title="$t('my.detail')" style="margin-top: 10px;">

          <template #icon>
            <img class="account-page__cell-icon" src="/img/yuer.png" alt="">

          </template>
          <div style="display: flex;justify-content: end;text-align: right;align-items: center;">
            <img class="account-page__cell-icon" src="/img/refresh.svg" alt="" style="margin-right: 10px;" @click="refresh()">
            {{ userInfo.money }}
          </div>
        </van-cell>
        <!-- <van-cell :title="$t('my.point')" v-if="userInfo.point">
          <template #icon>
            <img class="account-page__cell-icon" src="/img/jifen.png" alt="">
          </template>
          <div style="font-size: 14px;line-height: 1;">

            <van-progress :percentage="userInfo.point" stroke-width="18px"
                  color="linear-gradient(270deg,  #f43443, #f43443)" />
          </div>
        </van-cell> -->
        <van-cell :title="$t('my.recharge')" style="margin-top: 10px;" @click="doPay()">
          <template #icon>
            <img class="account-page__cell-icon" src="/img/deposit.svg" alt="">
          </template>
          <template #right-icon>

            <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
          </template>
        </van-cell>
        <van-cell :title="$t('my.withdraw')" @click="doWithdrawal()"><template #icon>
            <img class="account-page__cell-icon" src="/img/withdraw.svg" alt="">
          </template>
          <template #right-icon>

            <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
          </template>
        </van-cell>

        <van-cell :title="$t('my.account_detail')" @click="$router.push({ path: '/wallet/deposits' });"><template #icon>
            <img class="account-page__cell-icon" src="/img/chart.svg" alt="">
          </template>
          <template #right-icon>

            <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
          </template>
        </van-cell>
        <van-cell :title="$t('my.my_statement')" @click="$router.push({ path: '/wallet/reports' });"><template #icon>
            <img class="account-page__cell-icon" src="/img/film.svg" alt="">
          </template>
          <template #right-icon>

            <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
          </template>
        </van-cell>
        <van-cell :title="$t('my.personal_center')" style="margin-top: 10px;"
          @click="$router.push({ path: '/account/profile' });"><template #icon>
            <img class="account-page__cell-icon" src="/img/film.svg" alt="">
          </template>
          <template #right-icon>

            <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
          </template>
        </van-cell>
        <div style="display: flex;">
          <van-cell style="width: 50%;" :title="$t('my.task_record')" @click="$router.push({ path: '/wallet/game-records' });"><template #icon>
              <img class="account-page__cell-icon" src="/img/film.svg" alt="">
            </template>
            <template #right-icon>

              <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
            </template>
          </van-cell>
          <van-cell style="width: 50%;" :title="$t('my.information_announcement')" @click="toNotice()"><template #icon>
              <img class="account-page__cell-icon" src="/img/mail.svg" alt="">
            </template>
            <template #right-icon>

              <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
            </template>
          </van-cell>
        </div>
<div style="display: flex;">
  
  <van-cell style="width: 50%;" :title="$t('my.online_service')" @click="toService()">
            <template #icon>
              <img class="account-page__cell-icon" src="/img/kefu.png" alt="">
            </template>
            <template #right-icon>

              <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
            </template>
          </van-cell>
          <van-cell style="width: 50%;" :title="$t('setting.setting')" @click="showSetting()"><template #icon>
              <img class="account-page__cell-icon" src="/img/shezhi.png" alt="">
            </template>
            <template #right-icon>

              <img class="account-page__cell-icon" src="/img/arrow_right.svg" style="margin-right: 0;" alt="">
            </template>
          </van-cell>
</div>


        <!-- <div class="app-content">
            <div class="account-page__finance">
            <div class="account-page__finance-item"  @click="doPay()">
              <van-icon class="account-page__icon" style="" name="peer-pay" />
              <span class="app-text">{{$t("my.recharge")}}</span>
            </div>
            <div class="app-line"></div>
            <div class="account-page__finance-item"  @click="doWithdrawal()">
              <van-icon class="account-page__icon" name="idcard" />
              <span class="app-text">{{$t("my.withdraw")}}</span>
            </div>
          </div>
            <div  class="account-page__wallet">
                <div class="account-page__part-1 van-hairline--bottom"  @click="$router.push({path:'/wallet/transactions'});">
                  <p class="app-flex-1 app-font-28 account-page__font-primary-color">{{$t("my.my_balance")}}</p>
                  <span class="app-font-28 account-page__font-gray">{{$t("my.detail")}}</span>
                  <van-icon class="account-page__font-gray" style="font-size: 28px" name="arrow" />
                </div>
                <div class="account-page__part-2">
                  <p class="app-balance van-ellipsis">{{this.userInfo.money}}</p>
                  <span class="app-font-28 account-page__font-gray">({{$t("reservation.unit")}} {{$t("my.balance")}})</span>
                  <div class="account-page__refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
                </div>

                <div class="account-page__part-2">
                  <p class="app-balance van-ellipsis">{{this.userInfo.point}}</p>
                  <span class="app-font-28 account-page__font-gray"> {{$t("my.point")}}</span>
                  <div class="account-page__refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
                </div>
            </div>
            <div :style="{ marginTop: menu_top +'px'}" class="account-page__menu" >
              <div class="account-page__menu-item" @click="$router.push({path:'/wallet/reports'});">
                <van-image class="account-page__menu-item-icon" src="/img/mine/baobiao.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.my_statement")}}</span>
              </div>
              <div class="account-page__menu-item" @click="$router.push({path:'/account/profile'});">
                <van-image class="account-page__menu-item-icon" src="/img/mine/user.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.personal_center")}}</span>
              </div>
              <div class="account-page__menu-item" @click="$router.push({path:'/wallet/deposits'});">
                <van-image class="account-page__menu-item-icon" src="/img/mine/mingxi.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.account_detail")}}</span>
              </div>
              <div class="account-page__menu-item" @click="$router.push({path:'/wallet/game-records'});">
                <van-image class="account-page__menu-item-icon" src="/img/mine/youxi.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.task_record")}}</span>
              </div>
              <div class="account-page__menu-item" @click="toNotice()">
                <van-image class="account-page__menu-item-icon" src="/img/mine/gonggao.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.information_announcement")}}</span>
              </div>
              <div class="account-page__menu-item" @click="toService()">
                <van-image class="account-page__menu-item-icon" src="/img/mine/kefu_1.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="account-page__menu-item-label" >{{$t("my.online_service")}}</span>
              </div>
            </div>
         </div> -->
      </van-pull-refresh>
    </div>

  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import vip_detail from '@/assets/images/shared/vip_detail.jpg'
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 40,
      isLoading: false
    };
  },
  methods: {
    onImgPreView() {
      // 点击轮播图时,通过数据拿到当前索引,根据当前索引创建图片预览,设置默认图片
      ImagePreview({
        images: [vip_detail], //点击后的图片。
        startPosition: 0, //index默认为0，提供的起始位置
      });
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          // this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/auth/login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/account/settings' })
      } else {
        this.$router.push({ path: '/auth/login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/account/notices' })
      } else {
        this.$router.push({ path: '/auth/login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          // this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/auth/login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/account/profile' });
      } else {
        this.$router.push({ path: '/auth/login' })
      }
    },
    doPay() {
      // if (this.$store.getters.getBaseInfo.close_withdraw == 1) {
      //   this.$toast.fail(this.$t("setting.doPay"));
      // } else {
      //   this.$router.push({
      //     name: 'Recharge',
      //     params: {
      //       'balance': this.userInfo.money
      //     }
      //   })
      // }
      this.$toast('고객센터로 문의 바랍니다.');
    },
    doWithdrawal() {

      if (this.$store.getters.getBaseInfo.close_withdraw == 1) {
        this.$toast.fail(this.$t("setting.doWithdrawal"));
      } else {
        this.$http({
          method: 'get',
          url: 'user_get_bank'
        }).then(res => {
          if (res.data.is_bank) {
            this.$router.push("/wallet/withdraw");
          } else {
            this.$router.push("/account/payment-methods");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
        })
      }


    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("/support/online");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/auth/login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "/img/mine/avatar.png";
    }
  }
};
</script>

<style scoped lang="less" src="./index.styles.less"></style>
